module.exports = __webpack_public_path__ + "static/media/preview_play_button.60aca777.svg";